import { render, staticRenderFns } from "./CorretivaDefeitos.vue?vue&type=template&id=6d3fdcac&"
import script from "./CorretivaDefeitos.vue?vue&type=script&lang=js&"
export * from "./CorretivaDefeitos.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CorretivaDefeitos.vue?vue&type=style&index=1&id=6d3fdcac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports